import { useAppDispatch } from './state'
import {
  getNotifications as getNotificationsAPI,
  deleteNotification as deleteNotificationAPI,
  putNotification
} from '../api/notifications'
import {
  setNotifications,
  deleteNotification as deleteNotificationRedux,
  updateNotification,
  setNotificationsIsLoading
} from '../state/slices/notifications_slice'

export const useNotification = () => {
  const dispatch = useAppDispatch()

  const getNotifications = async () => {
    dispatch(setNotificationsIsLoading(true))
    try {
      const result = await getNotificationsAPI()

      if (result.data) {
        dispatch(setNotifications(result.data))
      }
    } finally {
      dispatch(setNotificationsIsLoading(false))
    }
  }

  const deleteNotification = async (id: number) => {
    const result = await deleteNotificationAPI(id)

    if (result.data) {
      dispatch(deleteNotificationRedux(id))
    }
  }

  const readNotification = async (id: number) => {
    dispatch(setNotificationsIsLoading(true))
    try {
      const result = await putNotification(id)

      if (result.data) {
        dispatch(updateNotification(result.data))
      }
    } finally {
      dispatch(setNotificationsIsLoading(false))
    }
  }

  return {
    getNotifications,
    deleteNotification,
    readNotification
  }
}

export default useNotification
